import React from "react";
import { Navigate, Route } from "react-router-dom";
import MessageList from "pages/messages/MessageList";
import MessageRoom from "pages/messages/MessageRoom";
import { MESSAGING_ENABLED } from "constants/featureFlags";

const disabledElement = <Navigate to="/" replace />;

export const renderMessageFeatureRoutes = () => (
    <>
        <Route
            path="/messages"
            element={MESSAGING_ENABLED ? <MessageList /> : disabledElement}
        />
        <Route
            path="/messages/:messageRoomId"
            element={MESSAGING_ENABLED ? <MessageRoom /> : disabledElement}
        />
    </>
);
